import React, { useEffect, useState } from 'react';
import * as yup from 'yup'; //
import Form from 'react-bootstrap/Form';
import Select from 'react-select';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import useLookupModule from '../../../../../../hooks/Lookups/use-Lookup-Module';
import { GetReportSourceList } from '../../../../../../store/NTX/Reports/reportSlice';
import { DataIcons } from '../../../../../../assets/icons';
import { useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import useGetDynamicFormById from '../../../../../../hooks/Forms/useGetDynamicFormById';

const Step1 = ({ setCheckValidationStep1, setDataStep1 }) => {
  const { t, i18n } = useTranslation();
  const dispatch = useDispatch();
  const { FormId } = useParams();
  const [formData, setFormData] = useState({
    name: '',
    name2: '',
    moduleId: '',
    templateType: '2150d9ba-469a-4831-b91d-9ffa5446bbcf',

    viewName: '',
    pageSize: '',
    icon: '',
    reportSourceId: '',

    typeForm: '1',
    tableId: null,
    hasExtraInformation: 'false',
    hasExtraInformationRecord: 'false',
    hasExtraInformationType: 'false',
    FormRecordId: '',
    FormTypeId: '',
  });

  const { Module } = useLookupModule();
  const { DynamicFormListByID: data } = useGetDynamicFormById(FormId);

  useEffect(() => {
    if (data) {
      setFormData((prev) => ({
        ...prev,
        name: data.name || '',
        name2: data.name2 || '',
        moduleId: data.moduleId || '',
        icon: data.icon || '',
        templateType: '2150d9ba-469a-4831-b91d-9ffa5446bbcf',
        viewName: '',
        pageSize: '',
        reportSourceId: '',
        typeForm: '1',
        tableId: null,
        // hasExtraInformation: data.hasExtraInformation?.toString() || 'false',
        // hasExtraInformationRecord: data.hasExtraInformationRecord?.toString() || 'false',
        // hasExtraInformationType: data.hasExtraInformationType?.toString() || 'false',
        FormRecordId: '',
        FormTypeId: FormId,
      }));
    }
  }, [data]);
  useEffect(() => {
    dispatch(GetReportSourceList());
  }, [dispatch]);
  const { ReportSourceList } = useSelector((state) => state.Reports);

  //_______________________________________________
  // Define a validation schema using yup
  const validationSchema = yup.object().shape({
    name: yup.string().required(t('Name is required')),
    name2: yup.string().required(t('Name2 is required')),
    moduleId: yup.string().required(t('Module is required')),
    reportSourceId: yup.string().required(t('Table Name is required')),
    pageSize: yup.string().required(t('page Size is required')),
    // templateType: yup.string().required(t('page Size is required')),

    // FormRecordId: yup.string().when('typeForm', {
    //   is: '3',
    //   then: () =>
    //     yup
    //       .string()
    //       .notOneOf(['إختر', 'Choose'], 'Required')
    //       .required(() => t('Required')),
    // }),
  });

  const handleInputChange = async (e) => {
    const { name, value, options } = e.target;

    if (options !== undefined && name === 'reportSourceId') {
      let selectedOption = options[options.selectedIndex];
      setFormData({
        ...formData,
        typeForm: '3',
        FormRecordId: '',
        [name]: value,
        viewName: selectedOption.getAttribute('data-view-name') || null,
        tableId: selectedOption.getAttribute('data-table-id') || null,
        hasExtraInformation: selectedOption.getAttribute('data-has-extra-information') || 'false',
        hasExtraInformationRecord:
          selectedOption.getAttribute('data-has-extra-information-record') || 'false',
        hasExtraInformationType:
          selectedOption.getAttribute('data-has-extra-information-type') || 'false',
      });
    } else {
      setFormData({
        ...formData,
        [name]: value,
      });
    }
  };
 
  // Validate function
  const areAllFieldsFilled = () => {
    try {
      validationSchema.validateSync(formData, { abortEarly: false });
      return true; // All fields are filled
    } catch (error) {
      return false; // Some field is empty
    }
  };

  useEffect(() => {
    setCheckValidationStep1(areAllFieldsFilled());
    setDataStep1(formData);
  }, [formData]);
  //________________________

  return (
    <>
      <div className="row">
        <div className="col-xl-4">
          <div className="form-group mb-3">
            <label className="form-label">{t('LocalName')}</label>
            <Form.Control
              className="form-control"
              type="text"
              autoComplete="off"
              name="name2"
              value={formData.name2}
              // onChange={handleInputChange}
              disabled
            />
          </div>
        </div>
        <div className="col-xl-4">
          <div className="form-group mb-3">
            <label className="form-label">{t('GlobalName')}</label>
            <Form.Control
              className="form-control"
              type="text"
              autoComplete="off"
              name="name"
              value={formData.name}
              // onChange={handleInputChange}
              disabled
            />
          </div>
        </div>
        <div className="col-xl-4">
          <div className="form-group mb-3">
            <label className="form-label">{t('Application')}</label>
            <Form.Select
              className="form-select"
              name="moduleId"
              value={formData.moduleId}
              // onChange={handleInputChange}
              disabled>
              <option value="">{i18n.language === 'ar' ? 'إختر' : ''}</option>
              {Module &&
                Module?.map((item, idx) => (
                  <option key={++idx} value={item.id}>
                    {i18n.language === 'ar' ? item.name2 : item.name}
                  </option>
                ))}
            </Form.Select>
          </div>
        </div>
      </div>

      <div className="row">
        <div className="col-xl-4">
          <div className="form-group mb-3">
            <label className="form-label">{t('Data_Source')}</label>
            <Form.Select
              className="form-select mb-3"
              name="reportSourceId"
              value={formData.reportSourceId}
              // onChange={(e) => handleDataSourceSelect(e)}
              onChange={(e) => handleInputChange(e)}>
              <option value="">{i18n.language === 'ar' ? 'إختر' : 'Choose'}</option>
              {ReportSourceList &&
                ReportSourceList?.map((item, idx) => (
                  <option
                    key={item.id}
                    value={item.id}
                    data-view-name={item.viewName}
                    data-table-id={item.tableId}
                    data-has-extra-information={item.hasExtraInformation}
                    data-has-extra-information-record={item.hasExtraInformationRecord}
                    data-has-extra-information-type={item.hasExtraInformationType}>
                    {i18n.language === 'ar' ? item.name2 : item.name}
                  </option>
                ))}
            </Form.Select>
          </div>
        </div>

        <div className="col-xl-4">
          <div className="form-group mb-3">
            <label className="form-label">{t('Layout')}</label>
            <Form.Select
              className="form-select mb-3"
              name="pageSize"
              value={formData.pageSize}
              onChange={(e) => handleInputChange(e)}>
              <option value="">{i18n.language === 'ar' ? 'إختر' : 'Choose'}</option>
              <option value="Landscape">Landscape</option>
              <option value="Portrait">Portrait</option>
            </Form.Select>
          </div>
        </div>

        <div className="col-xl-4">
          <div className="form-group mb-3">
            <label className="form-label">{t('Icon')}</label>

            <Select
              classNamePrefix="react-select"
              // classNamePrefix="select"
              isSearchable={true}
              required
              options={DataIcons}
              onChange={(option) => setFormData({ ...formData, icon: option.value })}
              value={DataIcons.find((f) => f.value === formData.icon)}
              placeholder={i18n.language === 'ar' ? 'إختر' : 'Choose'}
            />
          </div>
        </div>
      </div>
    </>
  );
};
export default Step1;
